import React, { useState } from 'react';
import axios from 'axios';

export default function PhotoUploader({ label = 'Add Photo', onUpload, preview }) {
  const [uploading, setUploading] = useState(false);
  const [error, setError] = useState('');

  const handleFile = async (e) => {
    const file = e.target.files[0];
    if (!file) return;

    setUploading(true);
    try {
      // Convert to base64
      const base64 = await new Promise((resolve, reject) => {
        const reader = new FileReader();
        reader.onload = () => resolve(reader.result.split(',')[1]);
        reader.onerror = reject;
        reader.readAsDataURL(file);
      });

      const token = localStorage.getItem('token');
      const res = await axios.post(
        `${process.env.REACT_APP_API_URL}/api/upload/listing-photo`,
        { base64, fileType: file.type },
        { headers: { Authorization: `Bearer ${token}` } }
      );

      onUpload(res.data.url);
    } catch (err) {
      setError('Upload failed, please try again');
    } finally {
      setUploading(false);
    }
  };

  return (
    <div className="flex flex-col gap-1">
      <label className="relative flex flex-col items-center justify-center w-full aspect-square border-2 border-dashed border-sand-300 rounded-lg bg-sand-50 hover:bg-sand-100 transition-colors cursor-pointer overflow-hidden">
        {preview ? (
          <img src={preview} alt="Preview" className="absolute inset-0 w-full h-full object-cover" />
        ) : (
          <>
            <svg className="w-6 h-6 text-terra-400 mb-1" fill="none" viewBox="0 0 24 24" stroke="currentColor" strokeWidth={2}>
              <path strokeLinecap="round" strokeLinejoin="round" d="M12 4v16m8-8H4" />
            </svg>
            <span className="text-xs text-ink-400 text-center px-2 leading-relaxed">
              {uploading ? 'Uploading…' : label}
            </span>
          </>
        )}
        <input
          type="file"
          accept="image/*"
          className="sr-only"
          onChange={handleFile}
          disabled={uploading}
        />
      </label>
      {error && <p className="text-xs text-uae-red">{error}</p>}
    </div>
  );
}